import React, { forwardRef, useImperativeHandle } from 'react';
import ListSubheader from '@mui/material/ListSubheader';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Collapse from '@mui/material/Collapse';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';



const CamaraNestedList = forwardRef((props, ref) => {
  const [open, setOpen] = React.useState(false);
  const videoRef = React.useRef(null);

  useImperativeHandle(ref, () => ({
    comenzarTestCamara() {
    },
  }));

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <div>
      <List
        sx={{ width: '100%', maxWidth: 540, bgcolor: '#e2e2e2', alignContent: 'center'}}
        component="nav"
        aria-labelledby="nested-list-subheader"
        style={{ margin: 'auto' }}
        subheader={
          <ListSubheader component="div" id="nested-list-subheader" style={{ paddingTop: '5px'}} ></ListSubheader>
        }
      >
        <ListItemButton onClick={handleClick}>
          <ListItemText primary="Pruebas de cámara" />
          {open ? <ExpandLess /> : <ExpandMore />}
        </ListItemButton>
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding sx={{bgcolor:'background.paper'}}>
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemText primary="Acceso" />
              {props.acceso != null ? props.acceso? <span>Ok</span>: <span>No</span> : <span>?</span>}
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemText primary="Funcionamiento" />
              <video style={{ marginRight: '10px' }} autoPlay={true} width={40} height={40} ref={videoRef}></video>
              {props.funcionamiento != null ? props.funcionamiento? <span>Ok</span>: <span>No</span> : <span>?</span>}
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemText primary="Resoluciones" />
              {props.resolucionesCamara != null ? <span>{props.resolucionesCamara}</span> : <span>?</span>}
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemText primary="Resolución QVGA" />
              {props.resolucionQVGACamara != null ? props.resolucionQVGACamara? <span>Ok</span>: <span>No</span> : <span>?</span>}
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemText primary="Resolución VGA" />
              {props.resolucionVGACamara != null ? props.resolucionVGACamara? <span>Ok</span>: <span>No</span> : <span>?</span>}
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemText primary="Resolución HD" />
              {props.resolucionHDCamara != null ? props.resolucionHDCamara? <span>Ok</span>: <span>No</span> : <span>?</span>}
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemText primary="Resolución Full HD" />
              {props.resolucionFullHDCamara != null ? props.resolucionFullHDCamara? <span>Ok</span>: <span>No</span> : <span>?</span>}
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemText primary="Resolución 2K" />
              {props.resolucion2kCamara != null ? props.resolucion2kCamara? <span>Ok</span>: <span>No</span> : <span>?</span>}
            </ListItemButton>
            <ListItemButton sx={{ pl: 4 }}>
              <ListItemText primary="Resolución 4K" />
              {props.resolucion4kCamara != null ? props.resolucion4kCamara? <span>Ok</span>: <span>No</span> : <span>?</span>}
            </ListItemButton>
          </List>
        </Collapse>
      </List>
    </div>
  );
});

export default CamaraNestedList;